import intlTelInput from "intl-tel-input/intlTelInputWithUtils";
import { setupCities } from "./geo";
import { maybeDob, replaceDob, setupDobInteraction } from "./dob";
import { setupDatePicker } from "./datepicker";
import { setupValidation } from "./validation";
import {
  fixCheckboxes,
  fixInputClasses,
  fixSubmits,
  fixRadio,
  addCountries,
} from "./input-fixes";
import { setupPhone } from "./phone";

export default function setupApplication() {
  const switchLang = document.querySelector(
    "#switch-language",
  ) as HTMLElement | null;
  if (!switchLang) {
    return;
  }

  const dobs = maybeDob();
  if (dobs.length === 0) {
    return;
  }

  dobs.forEach((element) => {
    const dob = element as HTMLInputElement;
    const { dobDay, dobMonth, dobYear } = replaceDob(dob);
    const picker = setupDatePicker({ dob, dobDay, dobMonth, dobYear });
    setupDobInteraction(picker, { dob, dobDay, dobMonth, dobYear });

    if (!dobYear.value) {
      const startDate = new Date();
      startDate.setFullYear(startDate.getFullYear() - 18);
      picker.setDate(startDate, true);
    } else {
      const startDate = new Date(
        Number(dobYear.value),
        Number(dobMonth.value) - 1,
        Number(dobDay.value),
      );
      picker.setDate(startDate, true);
    }
  });

  function setupButton() {
    document.querySelectorAll("form").forEach((element) => {
      const form = element as HTMLFormElement;
      form.addEventListener("submit", () => {
        const phone = form.querySelector(
          "input[name='your-phone' i]",
        ) as HTMLInputElement;
        const full_number = intlTelInput.getInstance(phone)!.getNumber();
        phone.value = full_number;

        form
          .querySelectorAll("[name=dob-day],[name=dob-month],[name=dob-year]")
          .forEach((element) => element.remove());

        form.querySelector("[data-state-fill]")!.classList.add("hidden");
        form.querySelector("[data-state-send]")!.classList.add("hidden");
        form.querySelector("[data-state-spinner]")!.classList.remove("hidden");
        form.submit();
      });
    });
  }

  (async () => {
    await setupCities();
  })();

  if (import.meta.env.PROD) {
    fixSubmits();
    fixInputClasses();
  }
  fixCheckboxes();
  fixRadio();

  addCountries();
  setupPhone();
  setupValidation();
  setupButton();
}
